module.exports = __webpack_public_path__ + "images/project/type-select-template-0ae5fd92c205bbbfd9dc54979e8748d3.png";